import DateFilter from '@/components/date-filter';
import Prestation from "@/components/comptable/prestations-exploitations/prestation"
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
import store_operation from "@/store/mods/caisse/operations"
import store_config from "@/store/mods/parametres/config"
import { NumberToLetter } from 'convertir-nombre-lettre';
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import { utilMixins } from '@/utils/utils-mixins.js';
import $ from 'jquery'

export default {
    name: 'produits',
    mixins: [utilMixins],
    components: {
        DateFilter, Prestation, EnteteBonEtFacture
    },
    props: [],
    data() {
        return {
            vm_state: open_menu_state,
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            liste_produits_creances: [],

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_loading: true,
            is_empty: false,

            montant_total: 0,
            load_error: false,
            is_printing: false,
            filename: '',
            can_print: false,
            is_month: false,
            personnel_id: "",
            personnel: '',
            montant_en_lettre: '',
            is_recap: true,

            c_loading_percentage: 0,
            can_view_percentage: false,
            c_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,

            detail_toggler: 0,
            detail_prestations: [],
            detail_loading: false,
            detail_empty: false,
            detail_error: false,

            liste_personnel_roles: []
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }

        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                is_creance: 0,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                user_id: this.personnel_id
            }
            this.current_date_filter = data
            this.getProduitExploitation(data)
            this.is_month = true
        },

        personnel() {
            this.personnel_id = this.personnel.id

            this.current_date_filter.user_id = this.personnel_id
            this.getProduitExploitation(this.current_date_filter)
        },
    },

    computed: {
        
    },

    beforeDestroy() {
        if (this.c_refresh_timeout_id) {
            clearTimeout(this.c_refresh_timeout_id)
            this.c_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },

    mounted() {
        const ts = this;
        $(document).bind("click", function (e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });
        
        // this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]
        const data = {
            is_creance: 0,
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            user_id: this.personnel_id
        }
        this.current_date_filter = data
        this.getProduitExploitation(data)


        const tmpstamp = this.current_date.getHours()+''+this.current_date.getMinutes()+''+this.current_date.getFullYear()
        this.filename = 'Produits d\'exploitation_'+tmpstamp

        this.fetchListeCaissieres()
    },

    methods: {
        fetchListeCaissieres() {
            store_config.selectListeCaissieres().then((response) => {
                this.liste_personnel_roles = response
                const all_user = {
                    id: "",
                    nom: 'Tous(tes) les caissiers(es)',
                    titre: "",
                }
                this.liste_personnel_roles.unshift(all_user)
            })
        },

        countdownLoad() {
            const TOTAL_SECONDS = 25 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.c_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.c_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.c_loading_percentage = 0
                }
            }, 1000)
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        async getProduitExploitation(data) {
            this.montant_total = 0
            this.is_loading = true
            this.load_error = false

            await store_operation.getListeProduitsCreances(data).then((produits_creances) => {
                this.liste_produits_creances = produits_creances
                if (this.liste_produits_creances.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                    
                    this.liste_produits_creances.forEach(produit => {
                        produit.prestations.forEach(prestation => {
                            this.montant_total += prestation.montant
                        });
                    });
                }
                
                this.is_loading = false
                this.countdown_seconds_left = 0
                this.montant_en_lettre = NumberToLetter(this.montant_total)
            }).catch(() => {
                this.is_loading = false
                this.countdown_seconds_left = 0
                this.load_error = true
            })
        },

        fetchDetails(data_type) {
            this.detail_prestations = []
            this.detail_toggler = (this.detail_toggler == 0)?1:0
            this.current_date_filter.data_type = data_type
            this.detail_loading = true
            store_operation.getDetailsProduitsCreances(this.current_date_filter).then((response) => {
                this.detail_prestations = response
                if (this.detail_prestations.length > 0) {
                    this.detail_empty = false
                } else {
                    this.detail_empty = true
                }
                this.detail_loading = false
            }).catch(() => {
                this.detail_loading = false
                this.detail_error = true
            })
        },

        filterByDate(date) {
            const data = {
                is_creance: 0,
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                user_id: this.personnel_id
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.is_month = false
            this.getProduitExploitation(data)
        },

        printProduitExploitation(is_recap) {
            this.is_recap = is_recap
            this.can_print = true

            setTimeout(() => {
                
                window.print()
                this.can_print = false
            }, 500);
        },

        exportProduitExploitation(is_recap) {
            if(is_recap) {
                this.exportRecap()
            } else {
                this.exportDetail()
            }
        },

        exportDetail() {
            const exportData = []

            // Title and filters
            exportData.push(['Produits d\'exploitation'])
            exportData.push([])

            if (!this.is_month) {
                if (this.current_date_filter.one_date != '') {
                    exportData.push(['Du :', this.formatDateToDmY(this.current_date_filter.one_date)])
                } else {
                    exportData.push(['Du :', this.formatDateToDmY(this.current_date_filter.from_date) + ' au ' + this.formatDateToDmY(this.current_date_filter.to_date)])
                }
            } else {
                exportData.push(['Du mois de :', this.curr_month.lib])
            }

            if (this.personnel && this.personnel.id) {
                exportData.push(['Caissier(e) :', this.personnel.nom])
            }

            exportData.push([])

            // Detail groups
            this.liste_produits_creances.forEach(produit => {
                const sectionLabel = this.convertDataTypeToLibelle(produit.data_type)
                exportData.push([sectionLabel, 'Nombre : ' + produit.qte, 'Montant : ' + this.formatCurrency(produit.montant)])
                exportData.push(['Libellé', 'Qté', 'Montant'])

                if (Array.isArray(produit.prestations) && produit.prestations.length > 0) {
                    produit.prestations.forEach(prestation => {
                        exportData.push([
                            prestation.libelle || '',
                            prestation.qte || 0,
                            this.formatCurrency(prestation.montant)
                        ])
                    })
                }

                exportData.push(['Total', '', this.formatCurrency(produit.montant)])
                exportData.push([])
            })

            exportData.push(['TOTAL GLOBAL', '', this.formatCurrency(this.montant_total)])
            exportData.push(['Montant en lettre :', this.capitalizeFirstLetter(this.montant_en_lettre) + ' ' + this.principal_currency])

            this.generateExcelFile(exportData, 'Produits_exploitation_detail')
        },

        exportRecap() {
            // Prepare data for export
            const exportData = []
            
            // Add title and metadata
            exportData.push(['Produits d\'exploitation'])
            exportData.push([])
            
            // Add date filter info
            if (!this.is_month) {
                if (this.current_date_filter.one_date != '') {
                    exportData.push(['Du :', this.formatDateToDmY(this.current_date_filter.one_date)])
                } else {
                    exportData.push(['Du :', this.formatDateToDmY(this.current_date_filter.from_date) +' au '+ this.formatDateToDmY(this.current_date_filter.to_date)])
                }
            } else {
                exportData.push(['Du mois de: ', this.curr_month.lib])
            }
            
            // Add caissier info if selected
            if (this.personnel && this.personnel.id) {
                exportData.push(['Caissier(e):', this.personnel.nom])
            }
            
            exportData.push([])
            
            // Add headers
            exportData.push(['Prestation', 'Nombre', 'Montant'])
            
            // Add products data
            this.liste_produits_creances.forEach(produit => {
                exportData.push([
                    this.convertDataTypeToLibelle(produit.data_type),
                    produit.qte,
                    this.formatCurrency(produit.montant)
                ])
            })
            
            exportData.push([])
            exportData.push(['TOTAL', '', this.formatCurrency(this.montant_total)])
            
            // const currencyCode = (this.currency_info && this.currency_info.principal_currency) ? this.currency_info.principal_currency : 'F.CFA'
            exportData.push(['Montant en lettre:', this.capitalizeFirstLetter(this.montant_en_lettre)+' '+this.principal_currency])
            
            // Generate Excel file
            this.generateExcelFile(exportData, 'Produits_exploitation')
        },

        /**
         * Generate and download Excel file
         */
        generateExcelFile(data, filename) {
            try {
                const excelHtml = this.convertToExcelHtml(data)
                const blob = new Blob(["\uFEFF" + excelHtml], { type: 'application/vnd.ms-excel;charset=utf-8;' })
                const url = URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                
                const timestamp = new Date().getTime()
                link.download = filename + '_' + timestamp + '.xls'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                URL.revokeObjectURL(url)
                
            } catch (error) {
                console.error('Error generating Excel file:', error)
                this.$toasted.error('Erreur lors de l\'export Excel')
            }
        },

        /**
         * Convert data array to Excel-compatible HTML string
         */
        convertToExcelHtml(data) {
            const rows = data.map(row => {
                const cells = []

                if (row.length === 1) {
                    const value = this.escapeHtml((row[0] || '').toString().toUpperCase())
                    cells.push(`<td colspan="3" style="font-weight:bold;text-align:center;font-size:16px">${value}</td>`)
                } else {
                    const values = row.slice()
                    if (values.length === 2) {
                        values.push('')
                    }
                    values.forEach((cell, colIndex) => {
                        const cellValue = this.escapeHtml((cell || '').toString())
                        let style = ''

                        const isHeaderRow = ['Prestation', 'Libellé', 'Qté', 'Nombre', 'Montant'].includes(row[0]) && values.includes('Montant')
                        const isSectionRow = row[1] && row[1].toString().startsWith('Nombre :')
                        const isTotalRow = row[0] === 'TOTAL' || row[0] === 'Total' || row[0] === 'TOTAL GLOBAL'

                        if (isHeaderRow) {
                            style = 'font-weight:bold;text-align:center;'
                        } else if (isSectionRow) {
                            style = 'font-weight:bold;'
                        } else if (isTotalRow && colIndex === 0) {
                            style = 'font-weight:bold;'
                        } else if (colIndex === 2) {
                            style = 'text-align:right;'
                        }

                        cells.push(`<td${style ? ` style="${style}"` : ''}>${cellValue}</td>`)
                    })
                }

                return `<tr>${cells.join('')}</tr>`
            }).join('')

            return `<!DOCTYPE html>
                <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
                <head>
                <meta charset="UTF-8" />
                </head>
                <body>
                <table border="1" style="border-collapse:collapse;width:100%;font-family:Arial, sans-serif;">
                ${rows}
                </table>
                </body>
                </html>`
        },

        escapeHtml(value) {
            return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
        },
    }
}


